"use strict";
// Runs BEFORE any other module touches localStorage — must stay the first import
// in index.tsx and must not import anything else (AppStore/FinancingStore/
// firebase.ts etc. all read localStorage at module-evaluation time, so this has
// to win the race).
//
// i18next-localstorage-backend caches translation JSON under `i18next_res_*`
// keys with a 360-day TTL and never refetches on its own if the baked-in
// build stamp doesn't change (see window.__BUILD_NUMBER__ / SENTRY_RELEASE) —
// so a returning visitor can be stuck on stale translations for a long time.
// Bump LS_SCHEMA_VERSION whenever a change should force those cached
// translations to be refetched. A visitor whose stored version doesn't match
// gets only their `i18next*` keys removed — everything else in localStorage
// (financing_store, JWT keys, cookieConfig, …) is left untouched, since only
// the i18n cache is known to go stale this way.
const LS_SCHEMA_VERSION = '2026-11-03.1';
const LS_SCHEMA_VERSION_KEY = 'auto_ls_schema_version';
try {
    if (typeof window !== 'undefined' && window.localStorage) {
        const current = window.localStorage.getItem(LS_SCHEMA_VERSION_KEY);
        if (current !== LS_SCHEMA_VERSION) {
            const staleKeys = [];
            for (let i = 0; i < window.localStorage.length; i++) {
                const key = window.localStorage.key(i);
                if (key && key.includes('i18next'))
                    staleKeys.push(key);
            }
            staleKeys.forEach((key) => window.localStorage.removeItem(key));
            window.localStorage.setItem(LS_SCHEMA_VERSION_KEY, LS_SCHEMA_VERSION);
        }
    }
}
catch (e) {
    // private browsing / storage disabled — nothing to clear, nothing to break
}
